<template>
  <div class="address_field">
    <label>
      {{title}}
      <hint-button>
        <template v-slot:hint-text>
          Фактические <br> адреса
        </template>
      </hint-button>
    </label>
    <div class="current" v-show="currentAddresses.length > 0">
      <div v-for="(address, index) in currentAddresses" :key="index" class="address">
        <standart-filed :value="address" error-text="" disabled="true"></standart-filed>
        <div class="remove" @click="removeCurrent(index)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
            <path d="M15.875 4.04167L15.3069 13.2313C15.1618 15.5792 15.0892 16.7532 14.5007 17.5972C14.2097 18.0145 13.8351 18.3667 13.4006 18.6314C12.5219 19.1667 11.3457 19.1667 8.99335 19.1667C6.63786 19.1667 5.46011 19.1667 4.5808 18.6304C4.14607 18.3652 3.77133 18.0124 3.48046 17.5944C2.89214 16.749 2.82117 15.5734 2.67922 13.2222L2.125 4.04167" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M0.75 4.04167H17.25M12.7178 4.04167L12.092 2.75075C11.6763 1.89324 11.4684 1.46448 11.1099 1.19707C11.0304 1.13776 10.9462 1.085 10.8581 1.03931C10.4611 0.833333 9.98461 0.833333 9.03165 0.833333C8.05476 0.833333 7.56632 0.833333 7.16271 1.04794C7.07326 1.09551 6.9879 1.1504 6.90752 1.21207C6.54484 1.49031 6.34224 1.93476 5.93706 2.82365L5.38185 4.04167" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M6.70831 14.125L6.70831 8.625" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M11.2917 14.125L11.2917 8.625" stroke="#656565" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="process" v-show="addingProcess">
      <standart-filed
          :value="newAddress" @updated="newAddress = $event"
          error-text=""
      >
      </standart-filed>
      <div class="save" @click="saveNewAddress()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M7.33331 11L9.65677 13.0911C10.0523 13.4471 10.6669 13.3926 10.9936 12.9725L14.6666 8.25M11 20.1667C16.0626 20.1667 20.1666 16.0626 20.1666 11C20.1666 5.93739 16.0626 1.83333 11 1.83333C5.93737 1.83333 1.83331 5.93739 1.83331 11C1.83331 16.0626 5.93737 20.1667 11 20.1667Z" stroke="#69BE15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="remove" @click="removeNewAddress()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
          <path d="M15.875 4.04166L15.3069 13.2313C15.1618 15.5792 15.0892 16.7532 14.5007 17.5972C14.2097 18.0145 13.8351 18.3667 13.4006 18.6313C12.5219 19.1667 11.3457 19.1667 8.99335 19.1667C6.63786 19.1667 5.46011 19.1667 4.5808 18.6304C4.14607 18.3652 3.77133 18.0124 3.48046 17.5944C2.89214 16.749 2.82117 15.5734 2.67922 13.2222L2.125 4.04166" stroke="#FA4B61" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M0.75 4.04167H17.25M12.7178 4.04167L12.092 2.75075C11.6763 1.89323 11.4684 1.46448 11.1099 1.19707C11.0304 1.13776 10.9462 1.085 10.8581 1.03931C10.4611 0.833332 9.98461 0.833332 9.03165 0.833332C8.05476 0.833332 7.56632 0.833332 7.16271 1.04794C7.07326 1.09551 6.9879 1.1504 6.90752 1.21207C6.54484 1.49031 6.34224 1.93476 5.93706 2.82365L5.38185 4.04167" stroke="#FA4B61" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M6.70831 14.125L6.70831 8.625" stroke="#FA4B61" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M11.2917 14.125L11.2917 8.625" stroke="#FA4B61" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
    <div class="add_new_address" @click="addNewAddress()">
      <div class="cicle">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7.00021 3.7V10.3M10.3002 7L3.70021 7" stroke="#69BE15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span>Добавить адрес</span>
    </div>
  </div>
</template>

<script>

import StandartFiled from "@/components/share/StandartField";
import HintButton from "@/components/share/HintButton";
export default {
  name : "AddressFiled",
  components: {HintButton, StandartFiled},
  props : {
    title : String,
  },
  data() {
    return{
      currentAddresses : [],
      addingProcess: false,
      newAddress: "",
    }
  },
  methods: {
    removeCurrent : function(index) {
      this.currentAddresses.splice(index, 1);
    },
    addNewAddress : function() {
      this.addingProcess = true;
    },
    removeNewAddress : function() {
      this.addingProcess = false;
      this.newAddress = "";
    },
    saveNewAddress : function() {
      if(this.newAddress == "") {
        return;
      }

      this.addingProcess = false;
      this.currentAddresses.push(this.newAddress);
      this.newAddress = "";
    }
  }
}
</script>

<style scoped>
.address_field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

label {
  cursor: pointer;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  padding-left: 20px;

  display: flex;
  gap: 6px;
  height: 17.5px;
}

.standart_field lable {
  display: none;
}

.current {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.address {
  display: flex;
  gap: 8px;
}

.current .remove {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  display: none;
}

.process {
  display: flex;
  gap: 10px;
}

.process .save {
  border-radius: 8px;
  border: 1px solid rgba(105, 190, 21, 0.10);
  background: rgba(105, 190, 21, 0.10);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.process .remove {
  border-radius: 8px;
  border: 1px solid rgba(250, 75, 97, 0.08);
  background: rgba(250, 75, 97, 0.08);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.add_new_address {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  display: none;
}

.add_new_address .cicle {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--Green, #69BE15);
  border-radius: 100px;
}

.add_new_address span {
  color: #69BE15;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
</style>